import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import DocumentationIntroContent from './DocumentationIntroContent';

export default function DocIntroDialog({ show, onHide, threatModelProvided }) {
  return (
    <Modal show={show} onHide={onHide} size="xl" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>📚 Documentation Concepts Reference</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DocumentationIntroContent threatModelProvided={threatModelProvided} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
